export class ExportDataModel {
  public venueId: string;
  public venueName: string;
  public fromDate: string;
  public toDate: string;
  [param: string]: string | number;
}
